import {S3DataView} from './shared'

interface LogsTabProps {
    record: any
}

function LogsTab({record}: LogsTabProps) {
    return (
        <S3DataView 
            s3Ref={record?.data?.responseS3?.logs} 
            placeholder="No logs data"
            asText={true}
        />
    )
}

export default LogsTab
